import { ShieldCheck } from 'lucide-react'
import { TONE_CLASS } from '@/lib/tone'
import { cn } from '@/lib/utils'

export function AdminBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border px-1.5 text-[10px] font-semibold uppercase leading-4 tracking-wide',
        TONE_CLASS.progress,
        className
      )}
    >
      <ShieldCheck aria-hidden className="h-3 w-3" />
      Admin
    </span>
  )
}
